import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showPopup } from "~/redux/action-creaters/popup";
import { popupTypes } from "~/redux/reducers/popupReducer";
import { INTERCEPTOR_TRIGGER_IDS } from "~/utils/interceptorTriggers";

const TRIGGER_ID_TO_POPUP_TYPE: Record<string, string> = {
  [INTERCEPTOR_TRIGGER_IDS.pageDepth4]: popupTypes.interceptorPageDepth4,
  [INTERCEPTOR_TRIGGER_IDS.exitModelCatalog]:
    popupTypes.interceptorExitModelCatalog,
  [INTERCEPTOR_TRIGGER_IDS.timeOnSite3min]:
    popupTypes.interceptorTimeOnSite3min,
};

const INTERCEPTOR_POPUP_TYPES = Object.values(TRIGGER_ID_TO_POPUP_TYPE);

export const useInterceptorBridge = () => {
  const dispatch = useDispatch();
  const { visibleType } = useSelector((state: any) => state.popup);
  const { user } = useSelector((state: any) => state.user);
  const onTriggerRef = useRef<(payload: any) => boolean>(() => false);
  // Менеджерам и админам окна-перехватчики не нужны: заявку они себе не оставят.
  const isStaff = Boolean(user?.IS_MANAGER || user?.IS_ADMIN);

  useEffect(() => {
    onTriggerRef.current = (payload: any) => {
      const popupType = TRIGGER_ID_TO_POPUP_TYPE[payload?.triggerId];
      if (!popupType || isStaff) {
        return false;
      }
      const isInterceptorOpen = INTERCEPTOR_POPUP_TYPES.includes(visibleType);
      if (visibleType !== popupTypes.none && !isInterceptorOpen) {
        return false;
      }
      dispatch(showPopup(popupType, payload));
      return true;
    };
  }, [dispatch, visibleType, isStaff]);

  return useCallback((payload: any) => onTriggerRef.current(payload), []);
};
